import { defineComponent } from "vue";
import { isAex } from "@/brand";

import { COMPONENT_NAME, SVG } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    close: null,
  },
  computed: {
    displayedCloseIcon(): string {
      return SVG.close;
    },

    exampleImageSrc(): string {
      if (isAex) return "";
      return require("@/assets/images/selfie/selfie.png");
    },
  },
  methods: {
    handleClose(): void {
      this.$emit("close");
    },
  },
});
